import React, { useState, useRef } from 'react';

const OTPInput = ({ setModalOTP, length = 6 }) => {
  const [otp, setOtp] = useState(Array(length).fill(''));
  const inputs = useRef([]);

  const handleChange = (e, index) => {
    const { value } = e.target;

    // Only allow single-digit input
    if (value.match(/^\d$/)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      setModalOTP(newOtp.join('')); // Optionally join OTP as a string if needed

      // Move focus to the next input if it exists
      if (index < length - 1) {
        inputs.current[index + 1].focus();
      }
    } else if (value === '') {
      // If input is empty and backspace is pressed, clear the value and move focus to previous input
      const newOtp = [...otp];
      newOtp[index] = '';
      setOtp(newOtp);
      setModalOTP(newOtp.join(''));

      if (index > 0) {
        inputs.current[index - 1].focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && otp[index] === '') {
      // Clear the value at the current index and move focus to the previous input
      const newOtp = [...otp];
      newOtp[index] = '';
      setOtp(newOtp);
      setModalOTP(newOtp.join(''));

      if (index > 0) {
        inputs.current[index - 1].focus();
      }
    }
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      {otp.map((_, index) => (
        <input
          key={index}
          type="text"
          maxLength="1"
          value={otp[index]}
          onChange={(e) => handleChange(e, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          ref={(el) => (inputs.current[index] = el)}
          style={{
            width: '40px',
            height: '40px',
            margin: '0 5px',
            color: '#000',
            textAlign: 'center',
            fontSize: '18px',
            border: '1px solid #ccc',
            borderRadius: '4px',
          }}
        />
      ))}
    </div>
  );
};

export default OTPInput;
